import React from "react";

export default function NormalPaymentTable({ data }) {
  const table = {
    header: [
      {
        id: 1,
        title: "입금대기",
      },
      {
        id: 2,
        title: (
          <span>
            결제완료
            <br />
            (신용카드)
          </span>
        ),
      },
      {
        id: 3,
        title: (
          <span>
            결제완료
            <br />
            (무통장입금)
          </span>
        ),
      },
      {
        id: 4,
        title: (
          <span>
            배송완료
            <br />
            (구매확정 대기)
          </span>
        ),
      },
      {
        id: 5,
        title: "구매확정",
      },
      {
        id: 6,
        title: "최종 매출금액",
      },
    ],
  };
  return (
    <>
      <div className="p-2 bg-primary-blue text-white font-bold">
        정상 결제 정보
      </div>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {data?.waitingForDeposit?.cases}건
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.paymentCompletedCreditCard?.cases}건
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.paymentCompletedDeposit?.cases}건
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.deliveryCompleted?.cases}건
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.purchaseConfirmation?.cases}건
              </td>
              <td className="p-3 border font-bold border-[#dddddd] text-[#e80000]">
                {data?.finalTurnover?.cases}건
              </td>
            </tr>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {data?.waitingForDeposit?.amount}원
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.paymentCompletedCreditCard?.amount}원
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.paymentCompletedDeposit?.amount}원
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.deliveryCompleted?.amount}원
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.purchaseConfirmation?.amount}원
              </td>
              <td className="p-3 border font-bold border-[#dddddd] text-[#e80000]">
                {data?.finalTurnover?.amount}원
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
